import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import TransportPackagingOutgoingTable from "./Transport/Table";
import TransportPackagingUsedTable from "./Wrapping/Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import transportWrapIcon from "../../../../../assets/new-product-detail-cats/sub-icons/product-transport-icon.svg";
import ProdSubBox from "../../components/SubcategoryBox/";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const ProductTransportWrappingContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  // LCA mode uses new structure (Flow 31.2 with 31.2a and 31.2b)
  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("TRANSPORT_PACKAGING") || "Transport packaging"}
        isNormal={true}
        number={"31.2"}
        icon={transportWrapIcon}
      />
      <div>
        <ProdSubBox
          title={t("TRANSPORT_PACKAGING_INFO")}
          desc={t("TRANSPORT_PACKAGING_DESC")}
        />
        {shouldShowTable && (
          <TableLoadingWrapper
            tableId={`transport-packaging-used-${productId}`}
            minLoadTime={3000}
            maxLoadTime={20000}
          >
            <TransportPackagingUsedTable productId={productId} />
          </TableLoadingWrapper>
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
      <div style={{ marginTop: "20px" }}>
        <ProdSubBox
          title={
            t("TRANSPORT_PACKAGING_OUTGOING_INFO") ||
            "Transport packaging - Outgoing with transports"
          }
          desc={
            t("TRANSPORT_PACKAGING_OUTGOING_DESC") ||
            "Packaging used for outgoing transports such as pallets, cardboard boxes, protective wrap, styrofoam etc."
          }
        />
        {shouldShowTable && (
          <TableLoadingWrapper
            tableId={`transport-packaging-outgoing-${productId}`}
            minLoadTime={3000}
            maxLoadTime={20000}
          >
            <TransportPackagingOutgoingTable productId={productId} />
          </TableLoadingWrapper>
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default ProductTransportWrappingContents;
